const breadCrumbsInit = () => {
  document.querySelectorAll('.js-breadcrumbs-back').forEach(function (el) {
    var ref = document.referrer;
    if (ref && ref !== location.href) {
      el.setAttribute('href', ref);
    } else {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        history.back();
      });
    }
  });
}
breadCrumbsInit()